
































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ReserveType } from '@/types'

export interface SelectReserveTypeInfoItem {
  name: string
  nameKana: string
  reserveType: {
    input: SelectReserveTypeInfoReserveType
  }
  hasRank: {
    input: boolean
  }
}

export const defaultSelectReserveTypeInfoItem = (): SelectReserveTypeInfoItem => ({
  name: '',
  nameKana: '',
  reserveType: {
    input: SelectReserveTypeInfoReserveType.One
  },
  hasRank: {
    input: true
  }
})

export const SelectReserveTypeInfoReserveType = {
  Set: ReserveType.Set,
  Group: ReserveType.Group,
  One: 'one'
}
export type SelectReserveTypeInfoReserveType = typeof SelectReserveTypeInfoReserveType[keyof typeof SelectReserveTypeInfoReserveType]

@Component({
  components: {}
})
export default class SelectReserveTypeInfo extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  item!: SelectReserveTypeInfoItem

  @Prop({
    type: String,
    required: true
  })
  reserveType!: SelectReserveTypeInfoReserveType

  @Prop({
    type: Boolean,
    default: false
  })
  disabledSet!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledGroup!: boolean

  get cssCustomProperty(): any {
    return {
      '--width':
        this.item.reserveType.input !==
        this.selectReserveTypeSettingReserveType.One
          ? '100%'
          : '50%'
    }
  }

  get selectReserveTypeSettingReserveType(): any {
    return SelectReserveTypeInfoReserveType
  }

  get isReserveTypeOne(): boolean {
    return this.item.reserveType.input === SelectReserveTypeInfoReserveType.One
  }

  get isReserveTypeSet(): boolean {
    return (
      this.item.reserveType.input ===
      this.selectReserveTypeSettingReserveType.Set
    )
  }

  @Emit('change:reserve-type')
  onChangeReserveType(
    value: SelectReserveTypeInfoReserveType
  ): SelectReserveTypeInfoReserveType {
    return value
  }
}
